module.exports = __webpack_public_path__ + "static/media/sashimimochi.0715900e.png";